var map = {
  "./th-TH.ts": [
    "858",
    "7831"
  ],
  "./zh-CN": [
    "1537",
    "7834"
  ],
  "./en-US.ts": [
    "7863",
    "9004"
  ],
  "./zh-CN.ts": [
    "1537",
    "7834"
  ],
  "./th-TH": [
    "858",
    "7831"
  ],
  "./en-US": [
    "7863",
    "9004"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6005;
module.exports = webpackAsyncContext;
